module.exports = __webpack_public_path__ + "static/media/gc-framboise-solo.3c7046df.png";